import Checkbox from 'components/inputs/Checkbox';
import Immutable from 'immutable';
import React from 'react';
import { Doc } from 'records/Doc';
import { Page } from 'records/Page';
import { Submittal } from 'records/Submittal';
import { useTranslator, useDateFormatter } from '@bluebeam/react-i18n';

interface Props {
  submittal: Submittal;
  document: Doc;
  firstPage: Page;
  onDocThumbnailClick: (doc: Doc, submittal: Submittal) => void;
  selectedFiles: Immutable.Set<string>;
  onCheckboxChange: (checked: boolean, docId: string) => void;
  style: React.CSSProperties;
}

const ApprovedFile: React.FC<Props> = (props) => {
  const handleRowClick = (): void => {
    const { document, submittal, onDocThumbnailClick } = props;

    onDocThumbnailClick(document, submittal);
  };

  const handleCheckboxChange = (
    checked: boolean,
    evt: React.SyntheticEvent
  ): void => {
    evt.stopPropagation();

    const { onCheckboxChange, document } = props;

    onCheckboxChange(checked, document.documentid);
  };

  const { translate } = useTranslator(['submittalsPage']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'long',
  });

  const { submittal, document, firstPage, selectedFiles, style } = props;
  const categoryType: `${string}:${string}` =
    `submittalsPage:categories.${submittal.category.kind}` as `${string}:${string}`;
  const reviewerResponse: `${string}:${string}` =
    `submittalsPage:reviewerResponse.${submittal.reviewerresponse.kind}` as `${string}:${string}`;

  return (
    <div
      className="row py3 bgd-white-2 bb-3 black-1 size-16 bgd-primary-blue-opacity-10-h cursor-pointer"
      style={{ ...style, height: '112px' }}
      onClick={handleRowClick}
    >
      <div className="wrem-3 mr3 flex-center">
        <Checkbox
          id="something"
          onChange={handleCheckboxChange}
          checked={selectedFiles.has(document.documentid)}
        />
      </div>
      <div className="flex-center wrem-5 max-hrem-5 mr4">
        {/* TODO: make this use an Intersection Observer */}
        {/* TODO: Add polyfill for Intersection Observer */}
        <img
          alt={`Page thumbnail for ${document.filename}`}
          className="of-contain h100 w100"
          src={firstPage.thumbnailUrl}
        />
      </div>
      <div className="column justify-between grow-1 mr3">
        <div>
          <div className="medium truncate size-16 black-1 mb2">
            {document.filename}
          </div>
          <div className="light truncate">{translate(categoryType)}</div>
        </div>
        <div className="row justify-between light">
          <div>{translate(reviewerResponse)}</div>
          {dateFormatter?.format(new Date(submittal.reviewedon * 1000))}
        </div>
      </div>
    </div>
  );
};

export default ApprovedFile;
